import { gql, useQuery } from '@apollo/client'
import { useMemo } from 'react'
import { useSites } from 'store'

const OPERATION_SSID_NETWORKS = gql`
  query cmtSsidsNetworks($site_sf_id: ID!) {
    networks: cmtSsidsNetworks(site_sf_id: $site_sf_id) {
      label
      type
    }
  }
`

export const useSsidNetworks = () => {
  const [{ selected: sitesSelected }] = useSites()
  const sfId: string = useMemo(
    () => sitesSelected[0]?.sf_id as string,
    [sitesSelected]
  )

  const { loading, data, error } = useQuery(OPERATION_SSID_NETWORKS, {
    variables: { site_sf_id: sfId },
    skip: !sfId,
    fetchPolicy: 'cache-first'
  })

  const networksByType = useMemo(() => {
    if (!data?.networks) return { guest: [], private: [], business: [] }
    
    return data.networks.reduce((acc, network) => {
      let type = network.type.toLowerCase()
      
      if (type === 'other') {
        type = 'business'
      }
      
      if (acc[type]) {
        acc[type].push(network)
      } else if (type !== 'guest' && type !== 'private') {
        acc.business.push(network)
      }
      
      return acc
    }, { guest: [], private: [], business: [] })
  }, [data])

  return {
    loading,
    error: error?.message || null,
    networks: data?.networks || [],
    networksByType
  }
}

export default useSsidNetworks